import React from "react";
import { Modal } from "react-bootstrap";
import "./customcharacter.css";
import CharacterView from "./CharacterView";
import Personalizenew from "../../common/Personalize/Personalizenew";
import Dedication from "./Dedication";

const Index = (props) => {
    const {
        show,
        handleclosemodal,
        proceedsave,
        customization,
        setCustomCharData,
        defaultdedication
    } = props;
    const handleclose = () => {
        handleclosemodal();
    };
    return (
        <div className="container shadow-sm" style={{
            minHeight: '60vh',
            border: '1px solid #f3f3f3',
            padding: '30px',
            borderRadius: '10px',
            position: 'relative',
            maxWidth: '900px',
            width: '95%',
            margin: 'auto',
            backgroundColor: '#fff',
        }}>
            <div className="character-modal">
                <div className="" style={{

                }}>
                    {show == "bookinfo" ? (
                        <Dedication
                            onClose={handleclose}
                            onProceed={proceedsave}
                            customization={customization}
                            setCustomCharData={setCustomCharData}
                            defaultdedication={defaultdedication}
                        />
                    ) : (
                        <Personalizenew
                            show={show}
                            onClose={handleclose}
                            onProceed={proceedsave}
                            customization={customization}
                            setCustomCharData={setCustomCharData}
                            defaultdedication={defaultdedication}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default connect(Index);
